const { createSlice } = require('@reduxjs/toolkit');

const activeProductSlice = createSlice({
    name: "activeProduct",
    initialState: {
        activeProductName: "",
        
    },
    reducers: {
        setactiveProduct(state, action) {
            const activeProductName = action.payload;

            return state = {
                activeProductName
            };
            
           
        }
    },
});

export const { setactiveProduct } = activeProductSlice.actions;
export default activeProductSlice.reducer;